import { createAction } from '@reduxjs/toolkit';

export const resetDomainIdentity = createAction('login/resetDomainIdentity');

export const enableAuthStage = createAction('login/enableAuthStage');
